import { forwardRef, lazy, Suspense } from 'react';
import type { CardFormHandle } from './CardForm';

export type { CardFormHandle };

const CardFormImpl = lazy(() => import('./CardForm'));

/** Loads the Stripe card form (and Stripe.js) only on pages that need it. */
export const CardForm = forwardRef<CardFormHandle, { publishableKey: string }>(function LazyCardForm(props, ref) {
  return (
    <Suspense fallback={<div className="card-input muted">Carregando formulário do cartão…</div>}>
      <CardFormImpl ref={ref} {...props} />
    </Suspense>
  );
});
